<template>
    <div class="sr-table-heading d-flex align-center mb-2">
        <img v-if="image" :src="image" alt="Logo" width="28" height="28" />
        <SrHeadline v-if="title" level="2" class="mb-0 ml-3">
            {{ title }}
        </SrHeadline>
    </div>
</template>

<script>
import { SrHeadline } from '../SrHeadline';

export default {
    name: 'SrTableHeading',
    components: { SrHeadline },
    props: {
        showFooter: Boolean,
        title: {
            type: String,
            default: null,
        },
        image: {
            type: String,
            default: null,
        },
    },
};
</script>
